import { FC, useState, ChangeEvent } from 'react';
import IconButton from '@mui/material/IconButton';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import ListItem from '@mui/material/ListItem';
import Radio from '@mui/material/Radio';
import ListItemText from '@mui/material/ListItemText';
import { useTranslation } from 'react-i18next';
import { getSelectedOrder } from '../../../../store/orders/selectors';
import { useAppSelector } from '../../../../hooks/useAppStore';

type TProductExchangesMobile = {
  handleChange: (event: ChangeEvent<HTMLInputElement>) => void
  selectedValue: string
};

const ProductExchangesMobile: FC<TProductExchangesMobile> = ({ handleChange, selectedValue }) => {
  const [open, setOpen] = useState(false);
  const selectedOrder = useAppSelector(getSelectedOrder);
  const { t } = useTranslation('orders');

  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };

  const DrawerList = (
    <Box
      sx={{
        width: 'auto', px: 3, pb: 3, pt: 8,
      }}
      role="presentation"
    >
      <IconButton
        onClick={toggleDrawer(false)}
        sx={{ position: 'absolute', right: 8, top: 8 }}
      >
        <CloseIcon />
      </IconButton>
      {selectedOrder.lineItems?.map((value) => (
        <ListItem
          disablePadding
          key={value.lineItemGqlId}
          sx={{ pb: 2 }}
          secondaryAction={(
            <Radio
              value={value.lineItemGqlId}
              checked={selectedValue === value.lineItemGqlId}
              onChange={handleChange}
            />
          )}
        >
          <ListItemText
            primary={value.name}
            primaryTypographyProps={{ variant: 'subtitle2' }}
            secondary={`SKU: ${value.sku} | ${t('quantity')}: ${value.quantity}`}
          />
        </ListItem>
      ))}
    </Box>
  );

  return (
    <div>
      <Button
        variant="text"
        endIcon={<ExpandMoreRoundedIcon />}
        onClick={toggleDrawer(true)}
      >
        {t('viewLineItems')}
      </Button>
      <Drawer
        open={open}
        anchor="top"
        onClose={toggleDrawer(false)}
        PaperProps={{
          sx: {
            top: 'var(--template-frame-height, 0px)',
            backgroundImage: 'none',
            backgroundColor: 'background.paper',
          },
        }}
      >
        {DrawerList}
      </Drawer>
    </div>
  );
};

export {
  ProductExchangesMobile,
};
